<template>
  <div class="navbar">
    <f7-navbar class="navbar-container">
      <f7-nav-left class="navbar-item">
        <button class="open-panel" data-panel="left" @click="onMenuRight" :style="{ color: customization.mainColor }">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.33334 24C4.95556 24 4.63912 23.872 4.384 23.616C4.12889 23.36 4.00089 23.0436 4 22.6667C3.99912 22.2898 4.12712 21.9733 4.384 21.7173C4.64089 21.4613 4.95734 21.3333 5.33334 21.3333H26.6667C27.0444 21.3333 27.3613 21.4613 27.6173 21.7173C27.8733 21.9733 28.0009 22.2898 28 22.6667C27.9991 23.0436 27.8711 23.3604 27.616 23.6173C27.3609 23.8742 27.0444 24.0018 26.6667 24H5.33334ZM5.33334 17.3333C4.95556 17.3333 4.63912 17.2053 4.384 16.9493C4.12889 16.6933 4.00089 16.3769 4 16C3.99912 15.6231 4.12712 15.3067 4.384 15.0507C4.64089 14.7947 4.95734 14.6667 5.33334 14.6667H26.6667C27.0444 14.6667 27.3613 14.7947 27.6173 15.0507C27.8733 15.3067 28.0009 15.6231 28 16C27.9991 16.3769 27.8711 16.6938 27.616 16.9507C27.3609 17.2076 27.0444 17.3351 26.6667 17.3333H5.33334ZM5.33334 10.6667C4.95556 10.6667 4.63912 10.5387 4.384 10.2827C4.12889 10.0267 4.00089 9.71022 4 9.33333C3.99912 8.95644 4.12712 8.64 4.384 8.384C4.64089 8.128 4.95734 8 5.33334 8H26.6667C27.0444 8 27.3613 8.128 27.6173 8.384C27.8733 8.64 28.0009 8.95644 28 9.33333C27.9991 9.71022 27.8711 10.0271 27.616 10.284C27.3609 10.5409 27.0444 10.6684 26.6667 10.6667H5.33334Z"
              fill="currentColor" />
          </svg>
        </button>
      </f7-nav-left>

      <f7-nav-center class="navbar-center">
        <div class="logo_text">
          <div style="display: flex; justify-content: center;">
            <img v-if="isLogoShowed" :src="computedLogo" />
            <div v-if="!isLogoShowed" class="salesperson-name" @click="redirectToSiteUrl('home')">
              <div style="color:#7F7F7F">{{ SalesPersonFirst }}</div>
              <div style="color:black">{{ SalesPersonLast }}</div>
            </div>
          </div>
        </div>
      </f7-nav-center>

      <f7-nav-right class="navbar-item">
        <button class="open-panel" data-panel="right" @click="onMenuLeft" :style="{ color: customization.mainColor }">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M23 25C23 22.348 19.8663 20.2 16 20.2C12.1337 20.2 9 22.348 9 25M16 16.6C14.7623 16.6 13.5753 16.0943 12.7002 15.1941C11.825 14.2939 11.3333 13.073 11.3333 11.8C11.3333 10.527 11.825 9.30606 12.7002 8.40589C13.5753 7.50571 14.7623 7 16 7C17.2377 7 18.4247 7.50571 19.2998 8.40589C20.175 9.30606 20.6667 10.527 20.6667 11.8C20.6667 13.073 20.175 14.2939 19.2998 15.1941C18.4247 16.0943 17.2377 16.6 16 16.6Z"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>

        </button>
      </f7-nav-right>
    </f7-navbar>
    <div class="panel-overlay nav-position-fixed" @click="clearMargin"></div>

    <f7-panel right cover layout="light" :style="{ 'background-color': customization.mainColor }"
      class="nav-position-fixed right_nav">
      <div class="rightContainer">
        <div class="user_login_info">
          <div class="user_thumb">
            <img :src="imageUrl" alt="" title="" />
            <div class="user_details">
              <p :style="{ color: customization.fontColor }">
                Welcome,
                <span style="color:#fff">{{
                  customerUser.firstName + " " + customerUser.lastName
                }}</span>
              </p>
            </div>
            <a :href="customerUser.isDemoUser ? '#' : 'edit-user-profile/'">
              <div class="user_avatar">
                <img :src="customerUser.profilePhoto
                  ? customerUser.profilePhoto
                  : '/static/images/avatar.jpg'
                  " alt="" title="" />
              </div>
            </a>
          </div>
          <nav class="user-nav">
            <ul>

              <li :style="{ 'border-bottom-color': customization.iconColor }">
                <a :href="customerUser.isDemoUser ? '#' : 'edit-user-profile'" class="close-panel" @click="clearMargin">
                  <span class="dbc-icon dbc-icon-user-circle" :style="{ color: customization.iconColor }"></span>
                  <span :style="{
                    color: customization.fontColor,
                    'font-size': '16px',
                  }" class="right-nav-span">My Profile</span>
                </a>
              </li>

              <li v-if="videoMessageCount != 0" :style="{ 'border-bottom-color': customization.iconColor }">
                <a href="video-message" class="close-panel">
                  <span class="dbc-icon dbc-icon-video" :style="{ color: customization.iconColor }"></span>
                  <span :style="{
                    color: customization.fontColor,
                    'font-size': '16px',
                  }" class="right-nav-span">Video Messages</span>
                </a>
                <span class="badge" :style="{
                  color: customization.mainColor,
                  'background-color': customization.iconColor,
                }">{{ videoMessageCount }}</span>
              </li>

              <li v-if="slsPermission.recommendAFriend" :style="{ 'border-bottom-color': customization.iconColor }">
                <a href="recommendfriend" @click="setPageShare(SharepageEnum.history)" class="close-panel">
                  <span class="dbc-icon dbc-icon-users-three" :style="{ color: customization.iconColor }"></span>
                  <span :style="{
                    color: customization.fontColor,
                    'font-size': '16px',
                  }" class="right-nav-span">Refer</span>
                </a>
                <span class="badge" :style="{
                  color: customization.mainColor,
                  'background-color': customization.iconColor,
                }">{{ referralsCount }}</span>
              </li>
            </ul>
          </nav>
        </div>
        <div class="termContainer">
          <a href="terms" class="close-panel"> Terms and Conditions </a>
          <span :style="{ color: customization.fontColor }">and</span>
          <a href="policy" class="close-panel"> Privacy Policy </a>
        </div>
      </div>
    </f7-panel>

    <f7-panel left cover layout="light" class="nav-position-fixed left_nav"
      :style="{ 'background-color': customization.mainColor }">
      <nav class="icons_31 sidebar-nav">
        <list-menu-component :items="customButtons" :fontColor="customization.fontColor"
          :iconColor="customization.iconColor" @onClick="OnItemClick($event)"></list-menu-component>
      </nav>
    </f7-panel>
  </div>
</template>

<script>
/* eslint-disable */

import { mapState, mapGetters, mapActions } from "vuex";
import { Request } from "../shared/base.requests";
import config from "../../config/customer.api";
import iconHelper from "../helpers/menu.icon.helper";
import ListMenuComponent from "./home-page-components/list-menu-component.vue";
import { MenuItemsEnum } from "../shared/enums/menu.items";
import { PAGES } from "../shared/routes.constants";
import { referralsCounterHelper } from '@/helpers/referral-history.helper'
import { downloadVCF } from "../helpers/vcf.helper";
export default {
  components: { ListMenuComponent },
  name: "bc-navbar",
  mounted() {
    if (this.$store.state.login.isAuthorized) {
      Request.get(config.videoMessagesCount)
        .then((response) => {
          this.videoMessageCount = response;
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
  props: {
    title: {
      type: String,
      default: "Navbar",
    },
    backLink: {
      type: Boolean,
      default: false,
    },
    noRightMenu: {
      type: Boolean,
      default: false,
    },
    showLogo: {
      type: Boolean,
      default: true,
    },
    logoSrc:{
      type: String,
    }
  },
  data() {
    return {
      menuItems: {
        Dashboard: "/dashboard/",
        Account: "/account/overview/",
      },
      isLogoShowed: true,
      videoMessageCount: 0,
      hideTopNav: false,
    };
  },
  mounted: function () {
    this.clearMargin();
    if (this.isHomePage || this.showLogo) {
      this.isLogoShowed = true;
    } else {
      this.isLogoShowed = false;
    }
    if (this.company == null && this.isAuth == true)
      this.$store.dispatch("aboutCompany/loadDataByCompany").catch((x) => {
        this.$f7.mainView.router.load({
          url: "error",
        });
      });
  },
  methods: {
    ...mapActions("customPage", ["loadCustomPage"]),
    getIconClass(iconId) {
      return iconHelper.getIconClassById(iconId);
    },
    HasInventory() {
      if (this.company != null) return this.company.hasInventory == true;
      else return false;
    },
    IsVisible_li(b) {
      if (b.iconSystemId === MenuItemsEnum.Shop && this.HasInventory() == false)
        return false;
      if (
        b.iconSystemId === MenuItemsEnum.VideoMessage &&
        this.videoMessageCount == 0
      )
        return false;
      if (
        b.iconSystemId === MenuItemsEnum.Map &&
        this.company != null &&
        this.company.adress == null
      )
        return false;
      return true;
    },
    OnItemClick(b) {
      if (b.iconSystemId === MenuItemsEnum.Home && this.isHomePage) {
        this.clearMargin();
      }
      if (b.hasActivity && b.name != null) this.LogActivity(b.name);
      if (b.isClearMargin) this.clearMargin();
      if (b.iconSystemId === MenuItemsEnum.SocialMedia)
        this.setPage(this.pageEnum.Socials);
      if (b.iconSystemId === MenuItemsEnum.About)
        this.setPage(this.pageEnum.Media);
      if (
        b.iconSystemId === MenuItemsEnum.Phone ||
        b.iconSystemId === MenuItemsEnum.Email ||
        b.iconSystemId === MenuItemsEnum.Text
      )
        this.redirectW(b.url);
      if (b.iconSystemId === MenuItemsEnum.ShareToFriends)
        this.setPageShare(this.SharepageEnum.share);
      if (b.iconSystemId == MenuItemsEnum.AddToPhone) {
        this.LoadVCard();
        return;
      }
      if (b.iconSystemId == MenuItemsEnum.MyReferrals) {
        return this.$router.load({
          url: PAGES.RecommendAFriendHistory,
        });
      }
      if (this.isExternal(b)) {
        var win = window.open(b.url, "_blank");
        win.focus();
      } else {
        if (b.type === 3) {
          console.log(b.url.split("/"));
          this.loadCustomPage(b.url.split("/")[1]).then(
            this.$router.load({
              url: b.url,
            })
          );
        } else {
        }
        this.$router.load({
          url: b.url,
        });
      }
    },
    logOutClicked() {
      delete localStorage.token;
      sessionStorage.removeItem("last_location");
      // here, f7 router is unreliable. Use the browser API!
      window.location.replace("/#!//dashboard/");
      window.location.reload(true);
      // this.$f7.mainView.router.load({url: '/'})
    },
    LoadVCard() {
      this.clearMargin();
      const url = config.downloadVCF + "/" + this.salesGlobalId;
      downloadVCF(url, this.isStandalone);
    },
    setPage(args) {
      this.$store.dispatch("about/setPageAbout", args);
    },
    setPageShare(args) {
      this.$store.dispatch("recommendFriend/setPage", args);
    },
    redirectTo(url) {
      this.clearMargin();
      // if(url)
      // document.location.href = url;
    },
    redirectToSiteUrl(Url) {
      this.clearMargin();
      this.$router.load({
        url: Url,
      });
    },
    LogActivity(type) {
      if (type != null) Request.get(config.logCustomerActivity + type);
    },
    redirectW(url) {
      if (url) document.location.href = url;
    },
    onMenuLeft() {
      this.clearMargin();
      if (this.isHomePage) {
        var elem = document.getElementsByClassName("navbar-container");
        var elem2 = document.getElementsByClassName("right_nav")[0];
        var width = document.defaultView
          .getComputedStyle(elem2, null)
          .getPropertyValue("width");
        if (elem && elem.length != 0) {
          elem[0].style.marginLeft = "-" + width;
          if (elem.length > 1) {
            elem[1].style.marginLeft = "-" + width;
          }
        }
        var elem = document.getElementsByClassName("pagepage");
        if (elem && elem.length != 0) {
          elem[0].style.transform = "translateX(-" + width + ")";
          if (elem.length > 1) {
            elem[1].style.transform = "translateX(-" + width + ")";
          }
        }
      }
    },
    onMenuRight() {
      this.clearMargin();
      if (this.isHomePage) {
        var elem = document.getElementsByClassName("navbar-container");
        var elem2 = document.getElementsByClassName("left_nav")[0];
        var width = document.defaultView
          .getComputedStyle(elem2, null)
          .getPropertyValue("width");
        if (elem && elem.length != 0) {
          elem[0].style.marginLeft = width;
          if (elem.length > 1) {
            elem[1].style.marginLeft = width;
          }
        }
        var elem = document.getElementsByClassName("pagepage");
        if (elem && elem.length != 0) {
          elem[0].style.transform = "translateX(" + width + ")";
          if (elem.length > 1) {
            elem[1].style.transform = "translateX(" + width + ")";
          }
        }
      }
    },
    clearMargin() {
      var elem = document.getElementsByClassName("navbar-container");
      if (elem && elem.length != 0) {
        elem[0].style.marginLeft = "0";
        elem[0].style.marginLeft = "0";
        if (elem.length > 1) {
          elem[1].style.marginLeft = "0";
          elem[1].style.marginLeft = "0";
        }
      }
      var elem = document.getElementsByClassName("pagepage");
      if (elem && elem.length != 0) {
        elem[0].style.transform = "translateX(0)";
        elem[0].style.transform = "translateX(0)";
        if (elem.length > 1) {
          elem[1].style.transform = "translateX(0)";
          elem[1].style.transform = "translateX(0)";
        }
      }
    },
    showBrowser() {
      var ua = navigator.userAgent,
        tem,
        M =
          ua.match(
            /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
          ) || [];
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return "IE " + (tem[1] || "");
      }
      if (M[1] === "Chrome") {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null)
          return tem
            .slice(1)
            .join(" ")
            .replace("OPR", "Opera");
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
      if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
      return M[0];
    },
    mobileCheck() {
      var check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor);
      return check;
    },
    isRunningStandalone() {
      return window.matchMedia("(display-mode: standalone)").matches;
    },
    isExternal(button) {
      const urlReg = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&/=]*)/g;
      return urlReg.test(button.url);
    },
  },
  computed: {
    ...mapState("policies", ["policies"]),
    ...mapState("agents", ["currentAgents"]),
    ...mapGetters("claims", ["openClaims"]),
    ...mapGetters("common", ["customButtons"]),
    ...mapState({
      pageEnum: (state) => state.about.pagesEnum,
      logo: (state) => state.common.logo,
      customerUser: (state) => state.editUserProfile.customerUser,
      SalesPersonFirst: (state) =>
        state.common.salesPersonFullName.split(" ")[0],
      SalesPersonLast: (state) =>
        state.common.salesPersonFullName
          .split(" ")
          .splice(1)
          .join(""),
      imageUrl: (state) => state.common.companyMainImage,
      SharepageEnum: (state) => state.recommendFriend.pageEnum,
      company: (state) => state.aboutCompany.companyData,
      salesPersonPhone: (state) => state.common.phone,
      isAuth: (state) => state.login.isAuthorized,
      SalesSiteUrl: (state) => state.common.salesSite,
      slsPermission: (state) => state.common.slsPermission,
      industryId: (state) => state.common.industryId,
      salesGlobalId: (state) => state.common.salesGlobalId,
      inventoryId: (state) => state.common.inventoryId,
      customization: (state) => state.common.customization,
      referralsCount: (state) => referralsCounterHelper(state.recommendFriend.historyCount),
      isStandalone: (state) => state.standalone.isStandalone,
      computedLogo(){
        return this.logoSrc || this.logo
      }
    }),
    claimsFeatureEnabled() {
      return this.setting("claims.claims_enabled");
    },
    isHomePage() {
      return (
        this.$route.route.path == ":tokenId/" ||
        this.$route.route.path == "home"
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import "~styles/_variables.scss";

@font-face {
  font-family: "iconsCustomerApp";
  src: url("/static/fonts/iconsCustomerApp.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}

.navbar {
  height: $bc-navbar-height;
  box-shadow: 0 1px 4px -1px rgba(0, 0, 0, 0.35);
  color: $color-primary;
}

.navbar-item {
  align-self: stretch;
}

.navbar-item button {
  background: none;
  border: none;
  padding: 0;
  width: 67px;
  height: 67px;
  aspect-ratio: 1;
}

.navbar-item .open-panel {
  line-height: 1;
  display: grid;
  place-content: center;
}

.navbar-center {
  width: 100%;
  color: $color-primary;
  margin: 0;
  font-family: $title-font-family;
  font-weight: $title-font-weight;
  font-size: $title-font-size;
  text-transform: $title-text-transform;
  box-shadow: none;
}

.navbar-container {
  background-color: $color-white;
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  transition-duration: 0.3s;
}

.nav-position-fixed {
  position: fixed;
}

.salesperson-name {
  display: flex;
  padding-left: 20px;
  text-transform: none;
}

.rightContainer {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.termContainer {
  padding: 15px;
  font-size: 15px;
  margin-top: auto;
  text-align: center;
}

.right-nav-span {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// navbar.vue?0ec12b84